// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"520":"769af13e","643":"769af13e"}[chunkId] + ".chunk.css";
};